/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import Backdrop from 'components/backdrop/Backdrop';
import { makeStyles } from '@material-ui/core';
import UserEditorForm from '../userEditorSection/UserEditorForm';

const useStyles = makeStyles(theme => ({
  form: {
    '& > div > div': {
      '&:nth-child(1)': {
        marginTop: '0rem',
        width: '100%',
        display: 'grid',
        gridGap: '1rem',
        gridTemplateColumns: '1fr 1fr',
        [theme.breakpoints.down('lg')]: {
          gridTemplateColumns: '1fr',
        },
      },
    },
  },
}));

export default function UserEditor({
  editRoles,
  editMode,
  uiSchema,
  jsonSchema,
  updateUser,
  onClick,
  user,
  onSubmit,
  onSave,
  isValid,
  checkIfFormIsValid,
  showForm,
  isEditAllowed,
}) {
  const classes = useStyles();

  return (
    <>
      {!showForm && <Backdrop blocking={true} />}
      {showForm && (
        <UserEditorForm
          uiSchema={uiSchema}
          editMode={editMode}
          editRoles={editRoles}
          isEditAllowed={isEditAllowed}
          jsonSchema={jsonSchema}
          onClick={onClick}
          onSubmit={onSubmit}
          onSave={onSave}
          user={user}
          isValid={isValid}
          updateUser={updateUser}
          checkIfFormIsValid={checkIfFormIsValid}
          className={classes.form}
          firstName={user.firstName}
          lastName={user.lastName}
          email={user.emailAddress}
          userName={user.username}
        />
      )}
    </>
  );
}
